import _ from 'lodash'

export const WEEK_LABELS = ['日', '一', '二', '三', '四', '五', '六']

export const PickerType = {
  Date: 'date',
  DateRange: 'daterange',
  Time: 'time',
}

export const PickerTypes = _.values(PickerType)

export const TimeType = {
  hour: {
    value: 'hour',
    unit: '点',
    min: 0,
    max: 23,
    precision: 3,
  },
  minute: {
    value: 'minute',
    unit: '分',
    min: 0,
    max: 59,
    precision: 2,
  },
  second: {
    value: 'second',
    unit: '秒',
    min: 0,
    max: 59,
    precision: 1,
  },
}
